/**
 * 서비스 소개 페이지
 */

import Seo from "@/components/seo/Seo";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Briefcase,
  Building2,
  Home,
  MessageCircle,
  Newspaper,
  ShoppingBag,
} from "lucide-react";
import { Link } from "wouter";

const services = [
  {
    icon: Newspaper,
    title: "뉴스",
    description: "호주 한인 커뮤니티를 위한 최신 뉴스와 정보를 제공합니다.",
    link: "/news",
  },
  {
    icon: ShoppingBag,
    title: "중고거래",
    description: "안전하고 신뢰할 수 있는 중고거래 플랫폼입니다.",
    link: "/market",
  },
  {
    icon: Home,
    title: "부동산",
    description: "렌트, 매매, 쉐어 등 부동산 정보를 제공합니다.",
    link: "/real-estate",
  },
  {
    icon: Briefcase,
    title: "구인구직",
    description: "호주 한인을 위한 구인구직 정보를 제공합니다.",
    link: "/jobs",
  },
  {
    icon: MessageCircle,
    title: "동네톡톡",
    description: "이웃들과 소통하고 정보를 공유하는 커뮤니티입니다.",
    link: "/community-talk",
  },
  {
    icon: Building2,
    title: "비즈니스 디렉토리",
    description: "호주 한인 비즈니스 정보를 한눈에 확인하세요.",
    link: "/business-directory",
  },
];

export default function Services() {
  return (
    <>
      <Seo
        title="서비스 소개 — OZK News"
        description="OZK News가 제공하는 다양한 서비스를 확인하세요."
        path="/services"
      />

      <div className="min-h-screen bg-background">
        <div className="max-w-6xl mx-auto px-4 py-12">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold mb-4">서비스 소개</h1>
            <p className="text-lg text-muted-foreground">
              호주 한인 커뮤니티를 위한 종합 정보 플랫폼
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {services.map((service) => (
              <Link key={service.link} href={service.link}>
                <Card className="h-full hover:shadow-lg transition-shadow cursor-pointer">
                  <CardHeader>
                    <div className="w-12 h-12 rounded-lg bg-brand-primary/10 flex items-center justify-center mb-4">
                      <service.icon className="w-6 h-6 text-brand-primary" />
                    </div>
                    <CardTitle>{service.title}</CardTitle>
                  </CardHeader>
                  <CardContent>
                    <p className="text-muted-foreground">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
